import { defineAsyncComponent, AsyncComponentLoader } from 'vue';
import { reverse } from 'lodash-es' 

// 获取所有组件，该方法返回一个对象
const components = import.meta.glob('./**/*.vue');
 
export default function install(app: any) {
  // 遍历对象并注册异步组件
  for (const [key, value] of Object.entries(components)) {
    app.component('s-' + reverse(key.split('/'))[1], defineAsyncComponent(value as AsyncComponentLoader));
  }
}